/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <Gallery {...cmsData} />)
 * and then make these props fit the final module.
 */
import React from "react"
import { Section } from "@bw/bits"
import { Columns as ColumnsModule } from "@bw/modules"
// parse is used to ensure that HTML sent by the CMS is converted to React components
import parse from "html-react-parser"
import { graphql } from "gatsby"

const ContentOnColumns = ({
  suptitle,
  title,
  subtitle,
  button,
  buttonPosition,
  idAttribute,
  classAttribute,
  backgroundVariant,
  isFollowedByModuleWithBackgroundVariant,
  columns,
  numberOfColumns,
}) => {
  return (
    <Section
      {...{
        suptitle,
        title,
        subtitle,
        button,
        buttonPosition,
        idAttribute,
        classAttribute,
        backgroundVariant,
        isFollowedByModuleWithBackgroundVariant,
      }}
    >
      <ColumnsModule
        count={numberOfColumns.value}
        contents={columns.map(({ text, title }) => ({
          title,
          content: text ? parse(text) : null,
        }))}
      />
    </Section>
  )
}

export const query = graphql`
  fragment ContentOnColumnsModuleFragment on ContentOnColumnsModule {
    numberOfColumns {
      value
    }
    columns {
      text
      title
      type
    }
  }
`

export { ContentOnColumns }
